import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./operacao-financeira-listar/operacao-financeira-listar.module').then(m => m.OperacaoFinanceiraListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./operacao-financeira-editar/operacao-financeira-editar.module').then(m => m.OperacaoFinanceiraEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./operacao-financeira-inserir/operacao-financeira-inserir.module').then(m => m.OperacaoFinanceiraInserirModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./operacao-financeira-detalhar/operacao-financeira-detalhar.module').then(m => m.OperacaoFinanceiraDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class OperacaoFinanceiraAppRoutingModule { }